import React, { useState } from "react";
import { Typography } from "@mui/material";
import { Avatar, Switch } from "antd";
import FingerprintIcon from "@mui/icons-material/Fingerprint";
import MemoryType from "../../../service/memory/enum/MemoryType";
import { useReadMemory } from "../../generic/hooks/useReadMemory";
import { startRegistration } from "@simplewebauthn/browser";
import { getFullName } from "../../careprovider/visits/utils";

const WebAuthnSwitch = () => {
  const userDetails = useReadMemory(MemoryType.USER);
  const localChallenge = useReadMemory(MemoryType.CHALLENGE);

  const [isChecked, setIsChecked] = useState(
    localChallenge?.userIdentifier === userDetails?.userIdentifier
  );

  const registerPasskey = async (checked) => {
    if (checked) {
      try {
        const challenge = btoa(crypto.randomUUID());
        const userIdBuffer = new TextEncoder().encode(
          userDetails?.userIdentifier
        );
        const userIdBase64 = btoa(
          String.fromCharCode(...new Uint8Array(userIdBuffer))
        );

        const options = {
          challenge,
          rp: { name: window.location.host },
          user: {
            id: userIdBase64,
            name: getFullName(userDetails?.givenName, userDetails?.familyName),
            displayName: userDetails?.userIdentifier,
          },
          pubKeyCredParams: [{ type: "public-key", alg: -7 }],
          authenticatorSelection: {
            authenticatorAttachment: "platform",
            userVerification: "required",
          },
          attestation: "direct",
          timeout: 60000,
        };

        const authResult = await startRegistration(options);
        setIsChecked(Boolean(authResult));
        localStorage.setItem(
          MemoryType.CHALLENGE,
          JSON.stringify({
            ...authResult,
            userIdentifier: userDetails?.userIdentifier,
          })
        );
      } catch (error) {
        console.error("Passkey Registration Failed", error);
      }
    } else {
      localStorage.removeItem(MemoryType.CHALLENGE);
      setIsChecked(false);
    }
  };
  return (
    <>
      <Avatar
        icon={<FingerprintIcon />}
        style={{
          marginRight: "0.5em",
          backgroundColor: "var(--main-theme-color)",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      />
      <Typography textAlign="center" marginRight={"0.5em"}>
        Enable Biometric
      </Typography>
      <Switch
        checked={isChecked}
        onChange={registerPasskey}
        style={{ marginLeft: "auto" }}
      />
    </>
  );
};

export default WebAuthnSwitch;
